// Date formatting helpers
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const formatDateWithDay = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const dayName = date.toLocaleDateString('en-GB', { weekday: 'short' });
  const formatted = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
  return `${dayName}, ${formatted}`;
};

export const formatTime = (timeString) => {
  if (!timeString) return '';
  return timeString;
};

export const formatDateTime = (dateString, timeString) => {
  const date = formatDate(dateString);
  const time = formatTime(timeString);
  return time ? `${date} ${time}` : date;
};

export const getTodayDateString = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

export const isToday = (dateString) => {
  return dateString === getTodayDateString();
};

export const isFuture = (dateString) => {
  return dateString > getTodayDateString();
};

export const isPast = (dateString) => {
  return dateString < getTodayDateString();
};

export const groupByDate = (items, dateField = 'date') => {
  const grouped = items.reduce((groups, item) => {
    const date = item[dateField];
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(item);
    return groups;
  }, {});

  // Convert to array and sort by date
  return Object.keys(grouped)
    .sort()
    .map(date => ({
      date,
      games: grouped[date]
    }));
};

// Helper to compare times for sorting (handles null/undefined)
const compareTime = (time1, time2) => {
  // If both have no time, they're equal
  if (!time1 && !time2) return 0;
  // If only first has no time, it goes after
  if (!time1) return 1;
  // If only second has no time, it goes after
  if (!time2) return -1;

  // Both have times, compare them
  const [hour1, min1] = time1.split(':').map(Number);
  const [hour2, min2] = time2.split(':').map(Number);

  const minutes1 = hour1 * 60 + min1;
  const minutes2 = hour2 * 60 + min2;

  return minutes1 - minutes2;
};

// Group games by date and sort within each day by time, then category
export const groupGamesByDateSorted = (games, categories, dateField = 'date') => {
  const grouped = games.reduce((groups, game) => {
    const date = game[dateField];
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(game);
    return groups;
  }, {});

  // Convert to array and sort by date
  return Object.keys(grouped)
    .sort()
    .map(date => ({
      date,
      games: grouped[date].sort((a, b) => {
        // First, sort by start time
        const timeCompare = compareTime(a.startTime, b.startTime);
        if (timeCompare !== 0) return timeCompare;

        // If times are equal (or both null), sort by category name
        const catA = categories.find(c => c.id === a.categoryId);
        const catB = categories.find(c => c.id === b.categoryId);
        const nameA = catA?.name || '';
        const nameB = catB?.name || '';
        return nameA.localeCompare(nameB);
      })
    }));
};
